import { AgentDef, findAgentDefByText } from "../../apis/mgmt/api";
import { DataViewProps, useStatefulDataView } from "../common/DataView";
import { FilteredPaginatedListLayout, useApiTextFilteredList } from "../common/FilteredPaginatedList";
import { ListProps, useStatefulList } from "../common/List";
import { Paginator, PagingProps, useStatefulPaging } from "../common/Paging";
import { SimpleTextFilter } from "../common/SimpleTextFilter";
import { AgentDefList } from "./AgentDefList";

export const useAgentDefFilteredList = function () {
    return useApiTextFilteredList<AgentDef>({
        filterProps: useStatefulDataView(''),
        listProps: useStatefulList<AgentDef>(),
        pagingProps: useStatefulPaging(),
        apiQueryFunc: findAgentDefByText
    });
};

export const AgentDefFilteredList = function (props:{
    filterProps: DataViewProps<string>,
    listProps: ListProps<AgentDef>,
    pagingProps: PagingProps
}) {

    const { filterProps, listProps, pagingProps} = props;
    
    return (
        <FilteredPaginatedListLayout
            filter={<SimpleTextFilter {...filterProps} />}
            list={<AgentDefList {...listProps} />}
            paginator={<Paginator {...pagingProps} />}
        />
    );

};
